import React from 'react';

import type { MessageType } from 'common/components/CopyMagic/contexts/MessagesContext/MessagesContext.types';
import { MESSAGE_DATA_ROLES } from 'common/components/CopyMagic/constants';

import GreetingFirst from './templates/GreetingFirst';
import GreetingReturn from './templates/GreetingReturn';
import Loading from './templates/Loading';

import Assistant from './templates/Assistant';
import User from './templates/User';

import './style.scss';

type Props = {
  message?: MessageType;
  template?: 'GreetingFirst' | 'GreetingReturn' | 'Loading';
  last?: boolean;
  lastOfRelated?: boolean;
};

const STATIC_TEMPLATES = {
  GreetingFirst,
  GreetingReturn,
  Loading,
};

const Message = ({ message, template, last = false, lastOfRelated = false }: Props) => {
  if (template) {
    const Template = STATIC_TEMPLATES[template];
    return <Template last={last} />;
  }

  if (!message) return null;
  const props = { message, last, lastOfRelated };
  const {
    data: { role },
  } = message;
  if (role === MESSAGE_DATA_ROLES.ASSISTANT) return <Assistant {...props} />;
  if (role === MESSAGE_DATA_ROLES.USER) return <User {...props} />;

  return null;
};

export default Message;
